import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Console.css';
import { StateContext } from '../StateProvider';

import timecardIcon from '../../assets/Console/Landing/timecardIcon.png'
import taskIcon from '../../assets/Console/Landing/taskIcon.png'
import guideIcon from '../../assets/Console/Landing/guideIcon.png'
import petIcon from '../../assets/Console/Landing/petIcon.png'
import trainingIcon from '../../assets/Console/Landing/trainingIcon.png'
import performanceIcon from '../../assets/Console/Landing/performanceIcon.png'
import eventIcon from '../../assets/Console/Landing/eventIcon.png'
import payIcon from '../../assets/Console/Landing/payIcon.png'
import supportIcon from '../../assets/Console/Landing/supportIcon.png';

import arrowIcon from '../../assets/Landing/arrowIcon.png';
import impactIcon from '../../assets/Landing/impactIcon.png';

import AnnouncementsFeed from './components/Utils/AnnouncementsFeed';
import Footer from './../Footer';

function Console() {
    const { user, loggedIn, role, financialSummary } = useContext(StateContext);
    const navigate = useNavigate();
    const [totalAnimalsHelped, setTotalAnimalsHelped] = useState(0);

    useEffect(() => {
        if (financialSummary && financialSummary.totalRevenue) {
            setTotalAnimalsHelped(calculateAnimalsHelped(financialSummary.totalRevenue));
        }
    }, [financialSummary]);

    const calculateAnimalsHelped = (totalRevenue, supportPerAnimal = 20) => {
        const allocatedAmount = totalRevenue * 0.10; // 10% of totalRevenue allocated for animal support
        return Math.floor(allocatedAmount / supportPerAnimal); // Calculate animals helped
    };

    const handleMenuButtonClicked = (page) => {
        navigate(`${page}`);
        window.scrollTo(0, 0);
    }

    const handleImpactClicked = (event) => {
        if (!loggedIn) {
          event.preventDefault(); // Prevent default <Link> navigation
          navigate('/login'); // Redirect to login page
        }
    };

    return (
        <>
            <div className="store-2-container">
                <h4 className="console-header">
                    { (function () {
                        if (!user || !user.username) return "Hi, team!";

                        var nm = String(user.username).trim();
                        if (nm.length === 0) return "Hi, team!";

                        var parts = nm.split(" ");
                        var first = parts[0];

                        if (!first || first.length === 0) return "Hi, team!";

                        return "Hi, " + first + "!";
                        })()
                    }
                </h4>
                <h4 className='console-message'>Ready to make tails wag today?</h4>
                <div className="container store-menu-2-container">
                    <div className="row">
                        <div className="col store-menu-2-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-2-button-image" src={petIcon} alt="Clients Icon" onClick={() => handleMenuButtonClicked('pets')} />
                        </div>
                        <p className="store-menu-2-button-title">Clients</p>
                        </div>
                        <div className="col store-menu-2-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-2-button-image" src={taskIcon} alt="Tasks Icon" onClick={() => handleMenuButtonClicked('tasks')} />
                        </div>
                        <p className="store-menu-2-button-title">Tasks</p>
                        </div>
                        <div className="col store-menu-2-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-2-button-image" src={guideIcon} alt="Guides Icon" onClick={() => handleMenuButtonClicked('guides')} />
                        </div>
                        <p className="store-menu-2-button-title">SOP & Guides</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col store-menu-2-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-2-button-image" src={timecardIcon} alt="Dog Training Icon" onClick={() => handleMenuButtonClicked('clockInAndOut')} />
                        </div>
                        <p className="store-menu-2-button-title">Clock In/Out</p>
                        </div>
                        <div className="col store-menu-2-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-2-button-image" src={trainingIcon} alt="Adventure Icon" onClick={() => handleMenuButtonClicked('training')} />
                        </div>
                        <p className="store-menu-2-button-title">Training</p>
                        </div>
                        <div className="col store-menu-2-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-2-button-image" src={performanceIcon} alt="Food Icon" onClick={() => handleMenuButtonClicked('performance')} />
                        </div>
                        <p className="store-menu-2-button-title">Performance</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col store-menu-2-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-2-button-image" src={payIcon} alt="Pay Icon" onClick={() => handleMenuButtonClicked('paystubs')} />
                        </div>
                        <p className="store-menu-2-button-title">Pay Stubs</p>
                        </div>
                        <div className="col store-menu-2-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-2-button-image" src={eventIcon} alt="Apparels Icon" onClick={() => handleMenuButtonClicked('events')} />
                        </div>
                        <p className="store-menu-2-button-title">Events</p>
                        </div>
                        <div className="col store-menu-2-button-container">
                        <div className='store-button-image-container'>
                            <img className="store-menu-2-button-image" src={supportIcon} alt="Health & Wellness Icon" onClick={() => handleMenuButtonClicked('support')} />
                        </div>
                        <p className="store-menu-2-button-title">Help & Support</p>
                        </div>
                    </div>
                </div>
            </div>

            <AnnouncementsFeed />

            {/* Career Track */}
            <div className="staff-section-wrapper">
                <div className="staff-section-title">
                    <span>🚀</span> Your Career Track
                </div>
                <div className="career-track-card">
                    <p>You're currently in the <strong>Onboarding</strong> phase.</p>
                    <div className="career-track-progress">Training Completed: <strong>4/10 modules</strong></div>
                    <Link to="/staff/training" className="career-track-link">Continue Training</Link>
                </div>
            </div>

            {/* Daily Shop Brief */}
            <div className="staff-section-wrapper">
                <div className="staff-section-title">
                    <span>📊</span> Daily Brief
                </div>
                <div className="staff-section-grid">
                    <div className="brief-card">Total Pets: <strong>37</strong></div>
                    <div className="brief-card">Grooming: <strong>12</strong></div>
                    <div className="brief-card">Daycare: <strong>18</strong></div>
                    <div className="brief-card">Training: <strong>4</strong></div>
                    <div className="brief-card">Hotel: <strong>3</strong></div>
                    <div className="brief-card">Incidents: <strong>0</strong></div>
                </div>
            </div>

            <hr className='deals-breakline'/>

            <div className='container'>
                <Link to="/store/deals/impact" className="impact-highlight" onClick={handleImpactClicked}>
                    <div className="impact-highlight-card">
                        <div className='impact-highlight-card-items'>
                            <h3 className='impact-highlight-number'>{totalAnimalsHelped}</h3>
                            <h3 className='impact-highlight-paragraph'>Animals helped. Your support enables us to contribute to animal rescue and care.</h3>
                            <div className='impact-highlight-action'>
                            <h3 className='impact-highlight-button-title'>SEE OUR IMPACT</h3>
                            <img src={arrowIcon} className='impact-highlight-button'></img>
                        </div>
                        </div>
                        <div className="impact-highlight-card-items">
                            <img className='impact-highlight-icon' src={impactIcon}></img>
                        </div>
                    </div>
                </Link>
            </div>

            <Footer />
        </>
    );
}

export default Console;
